import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import YYImage from "@/pages/design/components/basic/image";
import defaultUrl from "@/resource/images/default-banner.png";
import { mapState } from "vuex";
import noImg from "@/assets/noimg.png";
export default {
  name: "PcBanner",
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    YYImage: YYImage
  },
  data: function data() {
    return {
      noImg: noImg,
      imgConfig: {
        "background-size": "cover",
        "background-position": "center"
      },
      defaultUrl: defaultUrl
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    imgHost: function imgHost(state) {
      return state.design.imgHost;
    }
  })), {}, {
    moduleData: function moduleData() {
      var _this = this;
      // banner
      var tempBanner = [];
      // 18 为 banner之间的padding
      var padding = parseInt(this.formData.pcBannerSpace);
      var num = this.formData.pcSizeNum || 1;
      var bannerWidth = (1200 - (this.formData.pcHorizontalPadding || 0) * 2 - padding * (num - 1)) / num;
      this.formData.pathLink.forEach(function (item) {
        tempBanner.push({
          style: {
            // 'background-image': 'url("'+ (this.imgHost + item.path) +'")',
            width: bannerWidth - padding + "px"
          },
          imgpath: item.path,
          styleSmall: {
            "background-image": 'url("' + item.path + '")',
            width: bannerWidth - padding * 2 + "px",
            height: _this.formData.pcHeight + "px"
          },
          height: _this.formData.pcHeight + "px",
          link: item.link,
          padding: padding / 2 + "px",
          outWidth: bannerWidth + "px"
        });
      });

      /* let pathlink = _.cloneDeep(this.formData.pathLink) */

      var arr = [];
      while (tempBanner.length > 0) {
        arr.push(tempBanner.splice(0, num));
      }
      return arr;
    },
    height: function height() {
      return "height: ".concat(this.formData.pcHeight, "px");
    },
    isShowDynamic: function isShowDynamic() {
      return this.formData.pcDynamic;
    }
  }),
  methods: {
    handleBannerEnter: function handleBannerEnter(name, i) {
      if (this.formData.pcDynamic) {
        this.$refs[name][i].classList.toggle("div_content_bg_hover");
      }
    },
    handleBannerLeave: function handleBannerLeave(name, i) {
      if (this.formData.pcDynamic) {
        this.$refs[name][i].classList.toggle("div_content_bg_hover");
      }
    },
    goToPage: function goToPage(data) {
      // if (data) {
      //   window.location.href = data
      // }
    },
    // rem转换
    px2rem: function px2rem() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return val / 75 + "rem";
    },
    log: function log(e, s) {
      // this.isHover = false
      //console.log("ok ", e, s);
    }
  }
};